import { checkGetter } from 'src/router';

const routes = [{
	path: '/dealer/:dealerId/vehicle/:vehicleId',
	name: 'VehicleDetailPublic',
	component: () => import('pages/public/VehicleDetail.vue'),
}, {
	path: '/callback',
	name: 'Callback',
	component: () => import('pages/Callback.vue'),
}, {
	path: '/browser',
	name: 'Browser',
	component: () => import('pages/Browser.vue'),
}, {
	path: '/login',
	meta: {
		checkStore: checkGetter('auth/isLoggedIn', false, '/'),
	},
	component: () => import('layouts/SpecialLayout.vue'),
	children: [{
		name: 'Login',
		path: '',
		component: () => import('pages/LoginPage.vue'),
	}],
}, {
	path: '/register',
	meta: {
		checkStore: checkGetter('auth/isLoggedIn', false, '/'),
	},
	component: () => import('layouts/SpecialLayout.vue'),
	children: [{
		name: 'Register',
		path: '',
		component: () => import('pages/RegisterPage.vue'),
	}],
}, {
	path: '/forgotpwd',
	meta: {
		checkStore: checkGetter('auth/isLoggedIn', false, '/'),
	},
	component: () => import('layouts/SpecialLayout.vue'),
	children: [{
		name: 'Forgotpwd',
		path: '',
		component: () => import('pages/ForgotpwdPage.vue'),
	}],
}, {
	path: '/resetPassword',
	meta: {
		checkStore: checkGetter('auth/isLoggedIn', false, '/'),
	},
	component: () => import('layouts/SpecialLayout.vue'),
	children: [{
		name: 'Resetpwd',
		path: '',
		component: () => import('pages/ResetpwdPage.vue'),
	}],
}, {
	path: '/',
	meta: {
		checkStore: checkGetter('auth/isLoggedIn', true, '/login'),
	},
	component: () => import('layouts/DefaultLayout.vue'),
	children: [{
		path: '',
		name: 'Overview',
		meta: {
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/OverviewPage.vue'),
	},
	{
		path: 'inventory',
		name: 'Inventoy',
		meta: {
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/Inventory.vue'),
	},
	{
		path: 'advertising',
		name: 'Advertising',
		meta: {
			keepAlive: false,
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/advertising/AdvertisingPage.vue'),
	},
	{
		path: 'advertising/:id',
		name: 'AdvertisingDetail',
		props: true,
		meta: {
			keepAlive: false,
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/advertising/AdvertisingDetailPage.vue'),
	},
	{
		path: 'defaultcampaign',
		name: 'DefaultCampaingDetail',
		meta: {
			keepAlive: false,
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/advertising/DefaultCampaignDetailPage.vue'),
	},
	{
		path: 'analytics/listings',
		name: 'Analytics',
		meta: {
			keepAlive: false,
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/AnalyticsPage.vue'),
	},
	{
		path: 'analytics/page',
		name: 'PageInsights',
		meta: {
			keepAlive: false,
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/PageInsights.vue'),
	},
	{
		path: 'settings',
		name: 'Settings',
		meta: {
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
		},
		component: () => import('pages/SettingsPage.vue'),
	},
	{
		path: 'invoices',
		name: 'Invoices',
		meta: {
			keepAlive: false,
		},
		component: () => import('pages/InvoicePage.vue'),
	},
	{
		path: 'help',
		name: 'Help',
		component: () => import('pages/HelpPage.vue'),
	},
	{
		path: 'admin/leads',
		name: 'Leads',
		meta: {
			checkStore: checkGetter('auth/isAdmin', true, '/'),
		},
		component: () => import('pages/admin/LeadsPage.vue'),
	},
	{
		path: 'admin/user',
		name: 'Users',
		meta: {
			checkStore: checkGetter('auth/isAdmin', true, '/'),
		},
		component: () => import('pages/admin/UsersPage.vue'),
	},
	{
		path: 'admin/user/:userId',
		name: 'User',
		meta: {
			checkStore: checkGetter('auth/isAdmin', true, '/'),
		},
		component: () => import('pages/admin/UserPage.vue'),
	},
	{
		path: 'setup',
		name: 'Setup',
		meta: {
			checkStore: checkGetter('auth/isSetupCompletedFirstPart', false, '/'),
		},
		component: () => import('pages/SetupPage.vue'),
	},
	{
		path: '/payment/packages',
		name: 'PaymentPackages',
		meta: {
			checkStore: [
				checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
				checkGetter('auth/isSetupCompleted', false, '/'),
			],
		},
		component: () => import('pages/payment/Packages.vue'),
	},
	{
		path: '/payment/checkout',
		name: 'PaymentCheckout',
		meta: {
			keepAlive: false,
			checkStore: [
				checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
				checkGetter('auth/isSetupCompleted', false, '/'),
			],
		},
		component: () => import('pages/payment/Checkout.vue'),
	},
	{
		path: '/payment/offerrequest',
		name: 'PaymentOfferRequest',
		meta: {
			keepAlive: false,
			checkStore: [
				checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
				checkGetter('auth/isSetupCompleted', false, '/'),
			],
		},
		component: () => import('pages/payment/OfferRequest.vue'),
	},
	{
		path: '/payment/offercheckout',
		name: 'PaymentOfferCheckout',
		meta: {
			keepAlive: false,
			checkStore: [
				checkGetter('auth/isSetupCompletedFirstPart', true, '/setup'),
				checkGetter('auth/isSetupCompleted', false, '/'),
			],
		},
		component: () => import('pages/payment/OfferCheckout.vue'),
	},
	{
		path: '/payment/confirmation',
		name: 'PaymentConfirmation',
		component: () => import('pages/payment/Confirmation.vue'),
	},
	{
		path: '/payment/offerconfirmation',
		name: 'PaymentOfferConfirmation',
		component: () => import('pages/payment/OfferConfirmation.vue'),
	}],
}, {
	path: '/hubspot/offer',
	name: 'HubspotOffer',
	component: () => import('pages/hubspot/OfferPage.vue'),
}];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
	routes.push({
		path: '*',
		name: '404',
		meta: {
			checkStore: checkGetter('auth/isLoggedIn', true, '/login'),
		},
		component: () => import('pages/Error404Page.vue'),
	});
}

export default routes;
